module.exports = __webpack_public_path__ + "static/media/Froes.08408672.png";